import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("clariva_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login" && window.location.pathname !== "/register" && !window.location.pathname.startsWith("/sign/")) {
      localStorage.removeItem("clariva_token");
      localStorage.removeItem("clariva_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
